/* eslint-disable no-bitwise */
import React, { useEffect } from 'react';

const RelatedStories = () => {
  const uuidv5 = () =>
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });

  useEffect(() => {
    const randomID = uuidv5();
    window.top.document
      .getElementsByClassName('cnxtemp1')[0]
      .setAttribute('id', randomID);
    window.top.document.getElementById(randomID).removeAttribute('class');
    window.top.cnxps.cmd.push(() => {
      window.top
        .cnxps({ playerId: '86fd0e84-5f99-4f4b-8281-4147bb00e49a' })
        .render(randomID);
    });
  }, []);

  return (
    <section className="finite-scroll__related-stories">
      <div className="finite-scroll__header">More Top Stories:</div>
      <script className="cnxtemp1" async />
      <div className="cnx-finite-scroll-connatix" />
    </section>
  );
};

export default RelatedStories;
